export default __webpack_public_path__ + "static/media/healthcare-abroad.567642dc.png";